import React from 'react'
import { Col, Row } from 'react-bootstrap'
import NumberFormat from 'react-number-format'
import config from '../../config/constant'
import './headerDetails.css'
import { HEADER_DETAILS_KEYS } from '../../utils/translation-constants'
import { useTranslation } from 'react-i18next';

export default function TdHeaderDetails({ option = {} }) {
  const {t}=useTranslation()
  return (
    <div className='approval-card-header '>
      <span>
        <span className='span1'>{t(HEADER_DETAILS_KEYS.ACCOUNT_NO)}. : {option?.debitAccNo}</span>
        <span className='mt-2 span2'>{option?.interestCredit}</span>
      </span>
      <span>
        <span className='mb-2 span3'>
          <span className='d-flex span3'>
            {option?.tdCcy} &nbsp;
            <NumberFormat
              value={option?.payInAmt}
              displayType={'text'}
              thousandSeparator={true}
              prefix={''}
              className='span3'
              fixedDecimalScale={true}
                decimalScale={2}
                allowEmptyFormatting
            />
          </span>
        </span>
        <span></span>
        <span className='mt-2 span2 text-right'>
          {option?.initDate !== null
            ? option?.initDate
            : '-'}
        </span>
      </span>
    </div>
  )
}
